import { useFormik } from "formik";
import React, { useState } from "react";
import {
  Divider,
  Button,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Autocomplete,
  Link,
} from "@mui/material";
import {
  BooleanRadioButtons,
  RadioButton,
} from "../components/BooleanRadioButtons";
import DeletePrompt from "../components/DeletePrompt";
import PlanPrompt from "../components/PlanPrompt";

import ClipLoader from "react-spinners/ClipLoader";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { signUpValidationSchema } from "../formValidation";
import "../App.css";
import NMIvalidation from "../NMIvalidator";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import DateAdapter from "@mui/lab/AdapterMoment";
import axios from "axios";
import plans from "../plan-configuration.json";
import { usePlacesWidget } from "react-google-autocomplete";
import { streetTypeCodeArray } from "./streetTypeCode.js";

function Connection(props) {
  let index = props.index;

  let item = { ...props.item };

  const [manualAddress, setManualAddress] = useState({
    streetNo: "",
    streetName: "",
    streetType: "",
    streetSuburb: "",
    streetState: "",
    streetPostcode: "",
  });

  const [collapsed, setCollapsed] = useState(false);
  const [complete, setComplete] = useState(true);
  const [manualAddressOpt, setManualAddressOpt] = useState(false);

  const [validPlanLoading, setValidPlanLoading] = useState(false);
  const [validPlanLoaded, setValidPlanLoaded] = useState(false);
  const [validPlan, setValidPlan] = useState(true);
  const [concessionCardHelperState, setConcessionCardHelperState] =
    useState("");
  const [openDeletePrompt, setOpenDeletePrompt] = React.useState(false);
  const [openPlanPrompt, setOpenPlanPrompt] = React.useState(false);

  const [invalidAddress, setInvalidAddress] = useState(false);

  const formik = useFormik({
    initialValues: {
      nmi: item.nmi,
    },
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema: signUpValidationSchema,
  });

  const handleChange = () => {
    setCollapsed((prev) => !prev);
  };

  const setConnectionId = (index, _connectionId) => {
    let newConnections = [...props.connectionsState.connections];
    newConnections[index].connectionId = _connectionId;
    props.connectionsState.setConnections(newConnections);
  };

  const postConnectionToPersistenceTable = (index) => {
    // console.log(item);
    const connectionData = {
      connectionId: item.connectionId,
      customerEmail: props.user[7].Value,
      planName: item.planName,
      formattedPlanName: item.formattedPlanName,
      planDescriptor: plans[item.planName].planDescriptor,
      address: item.address,
      nmi: item.nmi,
      moveInFlag: item.moveInFlag,
      moveInDate:
        item.moveInFlag === "true" ? item.moveInDate.format("DD/MM/yyyy") : "",
      concessionFlag: item.concessionFlag,
      lifeSupportFlag: item.lifeSupportFlag,
      lifesupportMachineType: item.lifeSupportMachineType,
      solarFlag: item.solarFlag,
      confirmed: props.connectionsState.connections[index].confirmed,
      concessionCardType: item.concessionCardtype,
      concessionCardNumber: item.concessionCardNumber,
      concessionCardExpiryDate:
        typeof item.concessionCardExpiryDate === "function"
          ? item.concessionCardExpiryDate.format("DD/MM/YYYY")
          : "",
      abn_number: item.abn_number,
      business_name: item.business_name,
    };
    axios
      .post(
        "https://b3bq9zjyp4.execute-api.ap-southeast-2.amazonaws.com/api/connection",
        connectionData
      )
      .then((response) => {
        console.log(response);
        setConnectionId(index, response.data.connectionId);
      });
  };

  const fillCafData = () => {
    let newCafState = { ...props.cafState.cafState };

    let newCafConnectionData = {
      customer_type_code:
        item.planName === "saSmartBusinessPlan" ? "COMPANY" : "RESIDENT",
      customer_sub_type_code:
        item.planName === "saSmartBusinessPlan" ? "MMCOM" : "MMRES",
      offering_code:
        item.planName === "saSmartBusinessPlan" ? "IO_SME_SB" : "IO_RES_SH",
      business_name: item.business_name,
      abn_number: item.abn_number,
      site_identifier: item.nmi ? item.nmi : "",
      site_lot_no: "",
      site_floor_no: "",
      site_floor_type: "",
      site_unit_no: "",
      site_unit_type: "",
      site_street_no: item.address.streetNo,
      site_street_no_suffix: "",
      site_street_name: item.address.streetName,
      site_street_type_code: streetTypeCodeArray[item.address.streetType],
      site_street_suffix: "",
      site_suburb: item.address.suburb,
      site_state: item.address.state,
      site_post_code: item.address.postcode,
      post_addr_1:
        item.address.streetNo +
        " " +
        item.address.streetName +
        " " +
        item.address.streetType,
      post_post_code: item.address.postcode,
      post_addr_2: item.address.suburb,
      post_addr_3: item.address.state,
      conc_card_type_code: item.concessionCardType,
      conc_expiry_date:
        typeof item.concessionCardExpiryDate === "function"
          ? item.concessionCardExpiryDate.format("DD/MM/YYYY")
          : "",
      conc_card_number: item.concessionCardNumber,
      transfer_move_in_date:
        item.moveInFlag === "true" ? item.moveInDate.format("DD/MM/YYYY") : "",
      user_defined_1: item.solarFlag === "true" ? "Y" : "N",
      transfer_type: item.moveInFlag === "true" ? "MOVEIN" : "TRANSFER",
      concession_flag: item.concessionFlag === "true" ? "Y" : "N",
      life_support_on_site: item.lifeSupportFlag === "true" ? "Y" : "N",
      ls_equipment_code: item.lifeSupportMachineType,
      ls_notes: item.lifeSupportNotes,
    };

    if (newCafState.connectionsCaf[index] === undefined) {
      newCafState.connectionsCaf.push(newCafConnectionData);
    } else {
      newCafState.connectionsCaf[index] = newCafConnectionData;
    }
    props.cafState.setCafState(newCafState);
  };

  const handleComplete = (e, index) => {
    let newConnections = [...props.connectionsState.connections];
    e.preventDefault();
    if (
      newConnections.find(
        (e, i) =>
          item.address.description === e.address.description && i !== index
      )
    ) {
      alert("Connection already added for this address!");
      return;
    }

    if (isFormComplete()) {
      fillCafData();
      newConnections[index].confirmed = true;
      props.connectionsState.setConnections(newConnections);
      props.connectionsState.handleUpdateConnections();
      postConnectionToPersistenceTable(index);
      setCollapsed(true);
    } else {
      handleCompleteAlerts();
    }
  };

  const handleCancel = (index) => {
    var newConnections = [...props.connectionsState.connections];
    newConnections.pop(index);
    props.connectionsState.setConnections(newConnections);
    props.connectionsState.handleUpdateConnections();
    let url =
      "https://b3bq9zjyp4.execute-api.ap-southeast-2.amazonaws.com/api/connection/";
    axios.delete(url + item.connectionId).then((response) => {});
  };

  const delay = (ms) =>
    new Promise((resolve) => setTimeout(() => resolve(), ms));

  const retryFetch = (
    url,
    connectionData = {},
    retries = 3,
    retryDelay = 1000,
    timeout
  ) => {
    return new Promise((resolve, reject) => {
      // check for timeout
      if (timeout) setTimeout(() => reject("error: timeout"), timeout);

      const wrapper = (n) => {
        fetch(url, {
          headers: { "Content-Type": "application/json" },
          method: "POST",
          body: JSON.stringify(connectionData),
        })
          .then((res) => resolve(res))
          .catch(async (err) => {
            if (n > 0) {
              await delay(retryDelay);
              wrapper(--n);
            } else {
              reject(err);
            }
          });
      };
      wrapper(retries);
    });
  };

  const handleManualAddressChange = (newAddress) => {
    setManualAddress(newAddress);
    let newConnections = [...props.connectionsState.connections];
    let tempAddress = { ...newConnections[index].address };

    tempAddress.streetNo = newAddress.streetNo;
    tempAddress.streetName = newAddress.streetName;
    tempAddress.streetType = newAddress.streetType;
    tempAddress.suburb = newAddress.suburb;
    tempAddress.state = newAddress.state;
    tempAddress.postcode = newAddress.postcode;

    newConnections[index].address = tempAddress;
    props.connectionsState.setConnections(newConnections);

    if (isAddressComplete()) {
      setValidPlanLoaded(true);
      setValidPlan(true);
      tempAddress.description = `${newAddress.streetNo} ${newAddress.streetName} ${newAddress.streetType}, ${newAddress.suburb} ${newAddress.state}, Australia`;
      newConnections[index].address = tempAddress;
      props.connectionsState.setConnections(newConnections);
    }
  };

  const handleAddressChange = (place) => {
    let newConnections = [...props.connectionsState.connections];
    let newAddress = { ...newConnections[index].address };
    try {
      let streetString = place.address_components[1].long_name.split(" ");
      let streetType = streetString[streetString.length - 1];
      let streetName = streetString.slice(0, -1).join(" ");
      newAddress.streetNo = place.address_components[0].long_name;
      newAddress.streetName = streetName;
      newAddress.streetType = streetType;
      newAddress.suburb = place.address_components[2].long_name;
      newAddress.state = place.address_components[4].short_name;
      newAddress.postcode = place.address_components[6].long_name;
      newAddress.description = `${newAddress.streetNo} ${newAddress.streetName} ${newAddress.streetType}, ${newAddress.suburb} ${newAddress.state}, Australia`;

      newConnections[index].address = newAddress;
      props.connectionsState.setConnections(newConnections);

      // if (item.planIndex === 2) {
      if (false) {
        //TEMP DISBALE MSATS CHECK ON FE
        let connectionData = {
          site_street_no: newAddress.streetNo,
          site_street_name: newAddress.streetName,
          site_state: newAddress.state,
          site_post_code: newAddress.postcode,
          TOU: item.planIndex !== 2,
        };
        setValidPlanLoading(true);

        retryFetch(
          "https://lwqwrndrm7.execute-api.ap-southeast-2.amazonaws.com/api/tariff",
          connectionData,
          3
        ).then((response) =>
          response.json().then((data) => {
            console.log(data);
            setValidPlan(data.validPlanSelection);
            setValidPlanLoading(false);
            setValidPlanLoaded(true);
          })
        );
      } else {
        setValidPlanLoaded(true);
        setValidPlan(true);
      }
    } catch (e) {
      setInvalidAddress(true);
      alert("Invalid address, please fill address manually");
    }
  };

  const handleConcessionCardTypeChange = (event, index) => {
    var newConnections = [...props.connectionsState.connections];
    newConnections[index].concessionCardType = event.target.value;
    props.connectionsState.setConnections(newConnections);
  };

  const validate_option_1 = (concessionCardNumber) => {
    if (concessionCardNumber.match(/^[0-9]{9}[A-Za-z]{1}$/gm)) {
      setConcessionCardHelperState("");
      return true;
    }
    setConcessionCardHelperState("Invalid Concession Card Number");
    return false;
  };

  const validate_option_2 = (concessionCardNumber) => {
    if (
      concessionCardNumber.match(
        /^[NVQWST]{1}[0-9A-Za-z]{3}[0-9]{4}[A-Za-z]?$/gm
      )
    ) {
      setConcessionCardHelperState("");
      return true;
    }
    setConcessionCardHelperState("Invalid Concession Card Number");
    return false;
  };

  const validate_option_3 = (concessionCardNumber) => {
    if (
      concessionCardNumber.match(
        /^[NVQWST]{1}[A-Za-z]{0,3}[0-9]{1,6}[A-Za-z]?$/gm
      ) &&
      concessionCardNumber.match(/^[A-Za-z0-9]{2,9}$/gm)
    ) {
      setConcessionCardHelperState("");
      return true;
    }
    setConcessionCardHelperState("Invalid Concession Card Number");
    return false;
  };

  const handleConcessionCardNumberChange = (event, index) => {
    let concessionCardNumber = event.target.value;
    let concessionCardType =
      props.connectionsState.connections[index].concessionCardType;

    const concession_codes_option_1 = [
      "CSHC",
      "DVASHC",
      "HCC",
      "PCC",
      "SA_ENERGY",
      "SATEMPCONC",
      "SCC",
    ];

    const concession_codes_option_2 = ["DVAPCC", "DVPC"];

    const concession_codes_option_3 = [
      "DVAGC",
      "DVAGEDA",
      "DVAGTPI",
      "DVAGWW",
      "NZWWP",
      "UKWWP",
    ];

    if (concession_codes_option_1.includes(concessionCardType)) {
      let isValidConcessionCode = validate_option_1(concessionCardNumber);
      if (!isValidConcessionCode) {
        return;
      }
    } else if (concession_codes_option_2.includes(concessionCardType)) {
      let isValidConcessionCode = validate_option_2(concessionCardNumber);
      if (!isValidConcessionCode) {
        return;
      }
    } else if (concession_codes_option_3.includes(concessionCardType)) {
      let isValidConcessionCode = validate_option_3(concessionCardNumber);
      if (!isValidConcessionCode) {
        return;
      }
    } else {
      console.log("No concession card selected");
      return;
    }

    var newConnections = [...props.connectionsState.connections];
    newConnections[index].concessionCardNumber = event.target.value;
    props.connectionsState.setConnections(newConnections);
  };

  const handleConcessionCardExpiryDateChange = (event, index) => {
    var newConnections = [...props.connectionsState.connections];
    newConnections[index].concessionCardExpiryDate = event;
    props.connectionsState.setConnections(newConnections);
  };

  const handleMoveInDateChange = (event, index) => {
    var newConnections = [...props.connectionsState.connections];
    newConnections[index].moveInDate = event;
    props.connectionsState.setConnections(newConnections);
  };

  const handleNMIchange = (event, index) => {
    var newConnections = [...props.connectionsState.connections];
    newConnections[index].nmi = event.target.value;
    props.connectionsState.setConnections(newConnections);
  };

  const handleLifeSupportNotesChange = (event, index) => {
    var newConnections = [...props.connectionsState.connections];
    newConnections[index].lifeSupportNotes = event.target.value;
    props.connectionsState.setConnections(newConnections);
  };

  const handleMoveInChange = (event, index) => {
    var newConnections = [...props.connectionsState.connections];

    if (props.connectionsState.sharedConnectionAnswers) {
      newConnections.forEach((e) => {
        e.moveInFlag = event.target.value;
      });
    } else {
      newConnections[index].moveInFlag = event.target.value;
    }
    props.connectionsState.setConnections(newConnections);
  };

  const handleSolarChange = (event, index) => {
    var newConnections = [...props.connectionsState.connections];

    if (props.connectionsState.sharedConnectionAnswers) {
      newConnections.forEach((e) => {
        e.solarFlag = event.target.value;
      });
    } else {
      newConnections[index].solarFlag = event.target.value;
    }
    props.connectionsState.setConnections(newConnections);
  };

  const handleConcessionChange = (event, index) => {
    var newConnections = [...props.connectionsState.connections];

    if (props.connectionsState.sharedConnectionAnswers) {
      newConnections.forEach((e) => {
        e.concessionFlag = event.target.value;
      });
    } else {
      newConnections[index].concessionFlag = event.target.value;
    }
    props.connectionsState.setConnections(newConnections);
  };

  const handleLifeSupportChange = (event, index) => {
    var newConnections = [...props.connectionsState.connections];

    if (props.connectionsState.sharedConnectionAnswers) {
      newConnections.forEach((e) => {
        e.lifeSupportFlag = event.target.value;
      });
    } else {
      newConnections[index].lifeSupportFlag = event.target.value;
    }

    props.connectionsState.setConnections(newConnections);
  };

  const handleLifeSupportMachineTypeChange = (event, index) => {
    var newConnections = [...props.connectionsState.connections];
    newConnections[index].lifeSupportMachineType = event.target.value;
    props.connectionsState.setConnections(newConnections);
  };

  const handleBusinessNameChange = (event, index) => {
    var newConnections = [...props.connectionsState.connections];
    newConnections[index].business_name = event.target.value;
    props.connectionsState.setConnections(newConnections);
  };

  const handleABNChange = (event, index) => {
    var newConnections = [...props.connectionsState.connections];
    newConnections[index].abn_number = event.target.value;
    props.connectionsState.setConnections(newConnections);
  };

  const isAddressComplete = () => {
    return (
      item.address.streetNo &&
      item.address.streetName &&
      item.address.streetType &&
      item.address.suburb &&
      item.address.postcode &&
      item.address.state
    );
  };

  const isMoveInComplete = () => {
    return (
      item.moveInFlag === "false" ||
      (item.moveInFlag === "true" && item.moveInDate !== null)
    );
  };

  const isLifeSupportComplete = () => {
    return (
      item.lifeSupportFlag === "false" ||
      (item.lifeSupportFlag === "true" &&
        item.lifeSupportMachineType !== "" &&
        item.lifeSupportMachineType !== "OTHER") ||
      (item.lifeSupportMachineType === "OTHER" &&
        item.lifeSupportNotes !== "") ||
      item.planName === "saSmartBusinessPlan"
    );
  };

  const isConcessionComplete = () => {
    return (
      item.concessionFlag === "false" ||
      (item.concessionFlag === "true" &&
        item.concessionCardType !== "" &&
        item.concessionCardNumber !== "" &&
        item.concessionCardExpiryDate !== "" &&
        concessionCardHelperState === "") ||
      item.planName === "saSmartBusinessPlan"
    );
  };

  const isSolarComplete = () => {
    return item.solarFlag !== "";
  };

  const isABNComplete = () => {
    return (
      item.planName === "saSustainableHomePlan" ||
      (item.abn_number !== "" && item.planName === "saSmartBusinessPlan")
    );
  };

  const isBusinessNameComplete = () => {
    return (
      item.planName === "saSustainableHomePlan" ||
      (item.business_name !== "" && item.planName === "saSmartBusinessPlan")
    );
  };

  const existingNMI = () => {
    let newConnections = [...props.connectionsState.connections];
    let existingNMI = false;
    newConnections.forEach((item, ind) => {
      if (ind === index || !item.nmi) return;
      if (item.nmi === newConnections[index].nmi) existingNMI = true;
    });
    return existingNMI;
  };

  const isNMIComplete = () => {
    return (
      !existingNMI() && ((item.nmi && NMIvalidation(item.nmi)) || !item.nmi)
    );
  };

  const isFormComplete = () => {
    // console.log("isAddressComplete", isAddressComplete());
    // console.log("isMoveInComplete", isMoveInComplete());
    // console.log("isLifeSupportComplete", isLifeSupportComplete());
    // console.log("isConcessionComplete", isConcessionComplete());
    // console.log("isSolarComplete", isSolarComplete());
    // console.log("isNMIComplete", isNMIComplete());
    // console.log("isABNComplete", isABNComplete());
    // console.log("isBusinessNameComplete", isBusinessNameComplete());
    return (
      isAddressComplete() &&
      isMoveInComplete() &&
      isLifeSupportComplete() &&
      isConcessionComplete() &&
      isSolarComplete() &&
      isNMIComplete() &&
      isABNComplete() &&
      isBusinessNameComplete()
    );
  };

  const handleCompleteAlerts = () => {
    if (existingNMI()) {
      alert("Cannot add connection with same NMI as another connection!");
    } else if (!isNMIComplete()) {
      alert("NMI input is incorrect");
    } else if (!isAddressComplete()) {
      alert("Please fill in all Address details");
    } else if (!isMoveInComplete()) {
      alert("Please fill in all Move In details");
    } else if (!isLifeSupportComplete()) {
      alert("Please fill in all Life Support details");
    } else if (!isConcessionComplete()) {
      alert("Please fill in all Concession details");
    } else if (!isSolarComplete()) {
      alert("Please fill in Solar details");
    } else {
      alert("Please answer all of the questions!");
    }
  };

  const southAustraliaBounds = new window.google.maps.LatLngBounds(
    new window.google.maps.LatLng(-38.09392046461529, 129.00361341649156),
    new window.google.maps.LatLng(-26.04986267652838, 140.95673744565673)
  );

  const { ref } = usePlacesWidget({
    options: {
      types: ["geocode"],
      componentRestrictions: { country: "au" },
      bounds: southAustraliaBounds,
      fields: ["address_components"],
      strictBounds: true,
    },
    onPlaceSelected: (place) => {
      handleAddressChange(place);
    },
    inputAutocompleteValue: "off",
  });

  React.useEffect(() => {
    if (isFormComplete()) {
      setValidPlan(true);
      setValidPlanLoaded(true);
      setCollapsed(true);
    }
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    let newConnections = [...props.connectionsState.connections];
    if (!item.initialDBFlag) {
      newConnections[index].confirmed = false;
    } else {
      fillCafData();
      newConnections[index].initialDBFlag = false;
    }
    props.connectionsState.setConnections(newConnections);
    setComplete(isFormComplete());
    // eslint-disable-next-line
  }, [
    item.address,
    item.nmi,
    item.moveInFlag,
    item.moveInDate,
    item.solarFlag,
    item.concessionFlag,
    item.lifeSupportFlag,
    item.lifeSupportMachineType,
    item.concessionCardType,
    item.concessionCardNumber,
    item.concessionCardExpiryDate,
    item.abn_number,
    item.business_name,
  ]);

  // React.useEffect(() => {
  //   if (!validPlan) {
  //     if (item.planIndex === 2) {
  //       console.log("INVALID");
  //       setOpenPlanPrompt(true);
  //       // alert(
  //       //   "Sorry - we can't connect a flat rate plan to a property with a smart meter. Choose Lightning or Millennium instead!"
  //       // );
  //     }
  //   }
  //   // eslint-disable-next-line
  // }, [validPlan]);

  return (
    <>
      <Accordion
        sx={{ py: 1, my: 1 }}
        elevation={2}
        key={index}
        expanded={!collapsed}
        className="property-connection-wrapper"
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          onClick={handleChange}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography
            variant="h5"
            sx={{ ml: 1 }}
            display={"inline-flex"}
            flexDirection="column"
            justifyContent={"center"}
          >
            {plans[item.planName].shortName}
          </Typography>
          <Typography
            variant="h5"
            sx={{ mx: 1 }}
            display={"inline-flex"}
            flexDirection="column"
            justifyContent={"center"}
          >
            |
          </Typography>
          <Typography
            variant="h6"
            display={"inline-flex"}
            flexDirection="column"
            justifyContent={"center"}
          >
            {item.address.description ? (
              <>{item.address.description}</>
            ) : (
              <>-</>
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Divider />
          <Box m={1}>
            <TextField
              label="Address"
              type="text"
              data-cy="google-places-autocomplete-input"
              inputRef={ref}
              fullWidth
              placeholder=""
              defaultValue={item.address.description}
              onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
            ></TextField>
          </Box>
          <Grid item xs={12} sm={12} md={12} m={1} align="right">
            <Link
              variant="body2"
              sx={{ cursor: "pointer" }}
              onClick={(e) => {
                e.preventDefault();
                setManualAddressOpt((manualAddressOpt) => !manualAddressOpt);
              }}
            >
              + Enter manually
            </Link>
          </Grid>
          {invalidAddress || manualAddressOpt ? (
            <Grid container spacing={1} justifyContent={"space-between"} p={1}>
              <Grid item xs={3} sm={3} md={2} lg={2} xl={2}>
                <TextField
                  id="streetNo"
                  name="streetNo"
                  label="Street No."
                  type="text"
                  onChange={(e) => {
                    let newAddress = {
                      ...manualAddress,
                      streetNo: e.target.value,
                    };
                    handleManualAddressChange(newAddress);
                  }}
                  value={item.address.streetNo || ""}
                  fullWidth
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={7} lg={7} xl={7}>
                <TextField
                  id="streetName"
                  name="streetName"
                  label="Street Name"
                  type="text"
                  onChange={(e) => {
                    let newAddress = {
                      ...manualAddress,
                      streetName: e.target.value,
                    };
                    handleManualAddressChange(newAddress);
                  }}
                  value={item.address.streetName || ""}
                  fullWidth
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                />
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                {/* OLD INPUT FOR STREET TYPE */}
                {/* <TextField
                  id="streetType"
                  name="streetType"
                  label="Street Type"
                  type="text"
                  onChange={(e) => {
                    let newAddress = {
                      ...manualAddress,
                      streetType: e.target.value,
                    };
                    handleManualAddressChange(newAddress);
                    console.log(item.address.streetType);
                  }}
                  value={item.address.streetType || ""}
                  fullWidth
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                /> */}
                <Autocomplete
                  autoHighlight={true}
                  clearIcon={null}
                  options={Object.keys(streetTypeCodeArray)}
                  value={item.address.streetType}
                  onChange={(e, newValue) => {
                    let newAddress = {
                      ...manualAddress,
                      streetType: newValue,
                    };
                    handleManualAddressChange(newAddress);
                    console.log(newValue);
                  }}
                  id="streetType"
                  renderInput={(params) => (
                    <TextField
                      name="streetType"
                      label="Street Type"
                      // error={
                      //   props.formik.touched[props.fieldID] &&
                      //   Boolean(props.formik.errors[props.fieldID])
                      // }
                      // helperText={
                      //   props.formik.touched[props.fieldID] &&
                      //   props.formik.errors[props.fieldID]
                      // }
                      {...params}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={7} lg={7} xl={7}>
                <TextField
                  id="suburb"
                  name="suburb"
                  label="Suburb"
                  type="text"
                  onChange={(e) => {
                    let newAddress = {
                      ...manualAddress,
                      suburb: e.target.value,
                    };
                    handleManualAddressChange(newAddress);
                  }}
                  value={item.address.suburb || ""}
                  fullWidth
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                />
              </Grid>
              <Grid item xs={3} sm={3} md={2} lg={2} xl={2}>
                <TextField
                  id="state"
                  name="state"
                  label="State"
                  type="text"
                  onChange={(e) => {
                    let newAddress = {
                      ...manualAddress,
                      state: e.target.value,
                    };
                    handleManualAddressChange(newAddress);
                  }}
                  value={item.address.state || ""}
                  fullWidth
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                />
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                <TextField
                  id="postcode"
                  name="postcode"
                  label="Postcode"
                  type="number"
                  onChange={(e) => {
                    let newAddress = {
                      ...manualAddress,
                      postcode: e.target.value,
                    };
                    handleManualAddressChange(newAddress);
                  }}
                  value={item.address.postcode || ""}
                  fullWidth
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                />
              </Grid>
            </Grid>
          ) : null}

          <Grid item xs={12} sm={12} md={12} m={1}>
            <TextField
              id="nmi"
              data-cy="nmi"
              name="nmi"
              label="NMI (Recommended)"
              type="text"
              autoComplete="off"
              onChange={formik.handleChange}
              onBlur={(e) => {
                formik.handleBlur(e);
                handleNMIchange(e, index);
              }}
              value={formik.values.nmi || ""}
              error={formik.touched.nmi && Boolean(formik.errors.nmi)}
              helperText={formik.touched.nmi && formik.errors.nmi}
              fullWidth
              onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
            />
          </Grid>
          <Grid item md={12} container justifyContent="center">
            <ClipLoader loading={validPlanLoading} size={50} />
            {validPlanLoading ? (
              <Typography sx={{ ml: 2, my: 2 }}>
                This could take a moment...
              </Typography>
            ) : (
              <></>
            )}
          </Grid>
          {validPlan && validPlanLoaded ? (
            <div className="property-questions-wrapper">
              {item.planName === "saSmartBusinessPlan" ? (
                <>
                  <Box sx={{ m: 1 }}>
                    <TextField
                      id="businessName"
                      data-cy="businessName"
                      name="businessName"
                      label="Business Name"
                      type="text"
                      autoComplete="off"
                      onChange={(e) => handleBusinessNameChange(e, index)}
                      value={item.business_name || ""}
                      fullWidth
                      onKeyDown={(evt) =>
                        evt.key === "," && evt.preventDefault()
                      }
                    />
                  </Box>
                  <Box sx={{ m: 1 }}>
                    <TextField
                      id="abn"
                      data-cy="abn"
                      name="abn"
                      label="Australian Business Number (ABN)"
                      type="text"
                      autoComplete="off"
                      onChange={(e) => handleABNChange(e, index)}
                      value={item.abn_number || ""}
                      fullWidth
                      onKeyDown={(evt) =>
                        evt.key === "," && evt.preventDefault()
                      }
                    />
                  </Box>
                </>
              ) : null}

              <BooleanRadioButtons
                label={"Are you about to move into this property?"}
                name={"moveInFlag"}
                value={
                  props.connectionsState.sharedConnectionAnswers
                    ? props.connectionsState.connections[0].moveInFlag
                    : item.moveInFlag
                }
                onChange={(e) => handleMoveInChange(e, index)}
                disabled={props.connectionsState.sharedConnectionAnswers}
              />
              {props.connectionsState.connections[index].moveInFlag ===
              "true" ? (
                <Box sx={{ my: 1 }}>
                  <Typography color="rgba(0,0,0,0.6)" fontSize="16px" m={1}>
                    Please select your move in date
                  </Typography>
                  <Typography
                    variant="body2"
                    color="rgba(0,0,0,0.6)"
                    fontSize="13px"
                    sx={{ m: 1 }}
                  >
                    Note - SA Power Network is not able to connect power on
                    weekends or public holidays
                  </Typography>
                  <Box m={1}>
                    <LocalizationProvider dateAdapter={DateAdapter}>
                      <DesktopDatePicker
                        disablePast
                        label="Expected move in date"
                        inputFormat="DD/MM/yyyy"
                        value={item.moveInDate}
                        onChange={(e) => handleMoveInDateChange(e, index)}
                        margin="normal"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            onKeyDown={(evt) =>
                              evt.key === "," && evt.preventDefault()
                            }
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
              ) : null}
              <RadioButton
                label={"Do you have a solar system installed at this site?"}
                name={"solarFlag"}
                data-cy="solar-flag"
                value={
                  props.connectionsState.sharedConnectionAnswers
                    ? props.connectionsState.connections[0].solarFlag
                    : item.solarFlag
                }
                onChange={(e) => handleSolarChange(e, index)}
                disabled={props.connectionsState.sharedConnectionAnswers}
              />
              {item.planName !== "saSmartBusinessPlan" ? (
                <>
                  <BooleanRadioButtons
                    label={
                      "Does a resident at this property hold a concession card?"
                    }
                    name={"concessionFlag"}
                    data-cy="concession-flag"
                    disablePast
                    value={
                      props.connectionsState.sharedConnectionAnswers
                        ? props.connectionsState.connections[0].concessionFlag
                        : item.concessionFlag
                    }
                    onChange={(e) => handleConcessionChange(e, index)}
                    disabled={props.connectionsState.sharedConnectionAnswers}
                  />
                  {props.connectionsState.connections[index].concessionFlag ===
                  "true" ? (
                    <Box sx={{ my: 1 }}>
                      <Grid my={1}>
                        <TextField
                          id="concessionCardName"
                          data-cy="concessionCardName"
                          name="concessionCardName"
                          label="Concession Card Name"
                          type="text"
                          disabled
                          value={`${props.user[5].Value} ${props.user[6].Value}`}
                          fullWidth
                          onKeyDown={(evt) =>
                            evt.key === "," && evt.preventDefault()
                          }
                        />
                      </Grid>
                      <FormControl fullWidth>
                        <InputLabel>Concession Card Type</InputLabel>
                        <Select
                          labelId="concession-card-type-select-label"
                          id="concessionCardType"
                          data-cy="concession-select"
                          value={item.concessionCardType || ""}
                          label="concession-card-type"
                          onChange={(e) =>
                            handleConcessionCardTypeChange(e, index)
                          }
                        >
                          <MenuItem value={"CSHC"}>
                            Commonwealth Seniors Health Card
                          </MenuItem>
                          <MenuItem value={"DVAGC"}>
                            Dept of Veterans Affairs Gold Card
                          </MenuItem>
                          <MenuItem value={"DVAGEDA"}>
                            DVA Gold Repatriation Health Card (EDA)
                          </MenuItem>
                          <MenuItem value={"DVAGTPI"}>
                            DVA Gold Card (Special Rate TPI Pension only)
                          </MenuItem>
                          <MenuItem value={"DVAGWW"}>
                            DVA Gold Repatriation Health Card (War Widow)
                          </MenuItem>
                          <MenuItem value={"DVAPCC"}>
                            DVA Pension Concession Card
                          </MenuItem>
                          <MenuItem value={"DVASHC"}>
                            Commonwealth Seniors Health Card
                          </MenuItem>
                          <MenuItem value={"DVPC"}>
                            DVA Pension Concession Card
                          </MenuItem>
                          <MenuItem value={"HCC"}>Health Care Card</MenuItem>
                          <MenuItem value={"NZWWP"}>
                            New Zealand War Widow Pension
                          </MenuItem>
                          <MenuItem value={"PCC"}>
                            Pensioner Concession Card
                          </MenuItem>
                          <MenuItem value={"SA_ENERGY"}>
                            South Australia Energy Concession
                          </MenuItem>
                          <MenuItem value={"SA_MHC"}>
                            South Australia Medical Heating and Cooling
                            Concessio
                          </MenuItem>
                          <MenuItem value={"SATEMPCONC"}>
                            South Australia Temporary Concession
                          </MenuItem>
                          <MenuItem value={"SCC"}>
                            SA State Concession Card
                          </MenuItem>
                          <MenuItem value={"UKWWP"}>
                            British War Widow Pension
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <Grid
                        container
                        my={1}
                        spacing={1}
                        justifyContent={"space-between"}
                      >
                        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                          <TextField
                            id="concessionCardNumber"
                            data-cy="concessionCardNumber"
                            name="concessionCardNumber"
                            label="Concession Card Number"
                            type="text"
                            onBlur={(e) => {
                              handleConcessionCardNumberChange(e, index);
                            }}
                            value={item.ConcessionCardNumber}
                            fullWidth
                            helperText={concessionCardHelperState}
                            error={Boolean(concessionCardHelperState)}
                            onKeyDown={(evt) =>
                              evt.key === "," && evt.preventDefault()
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                          <LocalizationProvider
                            fullWidth
                            dateAdapter={DateAdapter}
                          >
                            <DesktopDatePicker
                              disablePast
                              label="Expiry date"
                              inputFormat="DD/MM/yyyy"
                              value={item.concessionCardExpiryDate}
                              onChange={(e) =>
                                handleConcessionCardExpiryDateChange(e, index)
                              }
                              margin="normal"
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onKeyDown={(evt) =>
                                    evt.key === "," && evt.preventDefault()
                                  }
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                    </Box>
                  ) : null}

                  <BooleanRadioButtons
                    label={
                      "Does anyone at this property require life support equipment?"
                    }
                    name={"lifeSupportFlag"}
                    data-cy="life-support-flag"
                    value={
                      props.connectionsState.sharedConnectionAnswers
                        ? props.connectionsState.connections[0].lifeSupportFlag
                        : item.lifeSupportFlag
                    }
                    onChange={(e) => handleLifeSupportChange(e, index)}
                    disabled={props.connectionsState.sharedConnectionAnswers}
                  />
                  {props.connectionsState.connections[index].lifeSupportFlag ===
                  "true" ? (
                    <Box sx={{ my: 1 }}>
                      <Grid sx={{ mt: 1, mb: 3 }}>
                        <Typography variant="bodySubtle">
                          If your life support equipment is powered by both
                          electricity and gas, please inform your gas retailer
                          about the life support requirement at your premises,
                          as we are only responsible for the supply of
                          electricity to your property
                        </Typography>
                      </Grid>
                      <FormControl fullWidth>
                        <InputLabel>Life Support Equipment Type</InputLabel>
                        <Select
                          labelId="life-support-type-select-label"
                          id="lifeSupportType"
                          data-cy="lifeSupport-select"
                          value={item.lifeSupportMachineType || ""}
                          label="life-support-type"
                          onChange={(e) =>
                            handleLifeSupportMachineTypeChange(e, index)
                          }
                        >
                          <MenuItem value={"OC"}>Oxygen Concentrator</MenuItem>
                          <MenuItem value={"IPDM"}>
                            Intermittent Peritoneal Dialysis Machine
                          </MenuItem>
                          <MenuItem value={"KDM"}>
                            Kidney Dialysis Machine
                          </MenuItem>
                          <MenuItem value={"CPAPR"}>
                            Chronic Positive Airways Pressure Respirator
                          </MenuItem>
                          <MenuItem value={"CNSPE"}>
                            Crigler Najjar Syndrome Phototherapy Equipment
                          </MenuItem>
                          <MenuItem value={"VFLS"}>
                            Ventilator For Life Support
                          </MenuItem>
                          <MenuItem value={"OTHER"}>Other</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                  ) : null}
                  {props.connectionsState.connections[index]
                    .lifeSupportMachineType === "OTHER" ? (
                    <TextField
                      id="ls-notes"
                      data-cy="ls-notes"
                      name="ls-notes"
                      label="Equipment details"
                      required
                      type="text"
                      onChange={(e) => {
                        handleLifeSupportNotesChange(e, index);
                      }}
                      value={item.lifeSupportNotes || ""}
                      fullWidth
                      onKeyDown={(evt) =>
                        evt.key === "," && evt.preventDefault()
                      }
                    />
                  ) : null}
                </>
              ) : null}
            </div>
          ) : null}
          <Button
            sx={{ float: "right", mt: 1 }}
            variant="outlined"
            data-cy="confirm-connection-button"
            disabled={item.confirmed || !complete}
            onClick={(e) => handleComplete(e, index)}
          >
            Confirm
          </Button>
          {props.cart[index] ? undefined : (
            <Button
              sx={{ float: "right", mr: 1, mt: 1 }}
              variant="outlined"
              onClick={(e) => setOpenDeletePrompt(true)}
              color="warning"
            >
              Cancel
            </Button>
          )}
          {props.mediaQuery && item.confirmed ? (
            <Button
              sx={{ float: "right", mr: 1, mt: 1 }}
              variant="outlined"
              onClick={(e) => setOpenDeletePrompt(true)}
              color="error"
            >
              Delete
            </Button>
          ) : null}
        </AccordionDetails>
      </Accordion>
      <DeletePrompt
        open={openDeletePrompt}
        index={index}
        removeItem={handleCancel}
        handleDeleteConnection={props.handleDeleteConnection}
        handleClose={(e) =>
          setOpenDeletePrompt((openDeletePrompt) => !openDeletePrompt)
        }
      />
      <PlanPrompt
        open={openPlanPrompt}
        handleClose={(e) => {
          setOpenPlanPrompt((openPlanPrompt) => !openPlanPrompt);
          handleCancel(index);
          props.setOpenPlans(true);
        }}
      />
    </>
  );
}

export default Connection;
